import useHomepage from './use-homepage';

const useTransformMenus = (menus) => {
  const theHomepage = useHomepage();
  return (menus?.nodes || []).map(({
    items = [],
    ...menu
  }) => ({
    ...menu,
    items: items
      .map(({ homepage, ...item }) => {
        // if homepage switch is set, use the homepage as the page
        if (homepage) {
          return {
            ...item,
            page: theHomepage,
          };
        }
        return item;
      })
      // unpublished subpages are returned as null, remove them
      .map(({ subpages, ...item }) => ({
        ...item,
        subpages: subpages.filter(Boolean),
      }))
      // only items with a parent page or externalpage
      .filter(({ page, externalpage }) => page || externalpage),
  }));
};

export default useTransformMenus;
